module.exports = __webpack_public_path__ + "img/ic_qmarker_dumpster_lbl.b3ad4db5.png";